<template>
  <div class="device-manage">
    <deviceManageTopbar
      @changeStatus="changeStatus"
      @changeLoss="changeLoss"
      @changeHandle="changeHandle"
      @searchDevice="searchDevice"
      @searchStudent="searchStudent"
      @reset="reset"
    />
    <deviceList
      @create="create"
      v-bitmap="getListResult"
      :deviceList="deviceList"
      class="device-list"
    />
    <pagination
      :pageSize="pageSize"
      :total="total"
      @currentPageNumChange="currentPageNumChange"
      @handleSizeChange="handleSizeChange"
      class="device-pagination"
    />
    <deviceCreateEdit
      :isCreateEditShow.sync="isCreateEditShow"
      v-show="isCreateEditShow"
      :unboundList="unboundList"
      :editStudentInfo="editStudentInfo"
    />
  </div>
</template>

<script>
import deviceManageTopbar from "./components/device-manage-topbar/deviceManageTopbar.vue";
import deviceList from "./components/device-manage-devicelist/deviceList.vue";
import pagination from "@/components/pagination/pagination";
import deviceCreateEdit from "./components/device-create-edit/device-create-edit.vue";
export default {
  data() {
    return {
      getListResult: "nullData",
      // 显示更改设备号码弹出框
      isCreateEditShow: false,
      total: 0, // 总条数
      pageNum: 1, // 当前页码
      pageSize: 10, // 每页条数
      deviceList: [], // 学校所有设备绑定学生信息列表
      // 搜索条件
      searchInfo: {
        deviceId: "",
        status: "",
        lossStatus: "",
        gradeId: "",
        classId: "",
        studentName: "",
      },
      unboundList: [], // 未绑定设备号列表
      editStudentInfo: {}, // 选中修改的学生信息
    };
  },
  components: {
    deviceManageTopbar,
    deviceList,
    pagination,
    deviceCreateEdit,
  },
  provide() {
    return {
      refresh: this.refresh,
    };
  },
  created() {
    this.getSchoolBindDevice();
    this.selectnobinddevice();
  },
  methods: {
    // 重置
    reset() {
      Object.keys(this.searchInfo).forEach(
        (key) => (this.searchInfo[key] = "")
      );
      // console.log(this.searchInfo);
      this.refresh();
    },
    // 搜索设备号
    searchDevice(e) {
      console.log("设备号码==>", e);
      this.searchInfo.studentName = "";
      this.searchInfo.deviceId = e;
      this.refresh();
    },
    // 搜索学生姓名
    searchStudent(e) {
      console.log("学生姓名==>", e);
      this.searchInfo.deviceId = "";
      this.searchInfo.studentName = e;
      this.refresh();
    },
    // 状态切换
    changeStatus(e) {
      console.log("状态==>", e);
      this.searchInfo.status = e;
      this.refresh();
    },
    // 是否挂失状态切换
    changeLoss(e) {
      console.log("是否挂失==>", e);
      this.searchInfo.lossStatus = e;
      this.refresh();
    },
    // 选择班级
    changeHandle(e) {
      console.log("选中的班级==>", e);
      this.searchInfo.gradeId = e[0].gradeId;
      this.searchInfo.classId = e[1].classId;
      this.refresh();
    },
    // 刷新
    refresh() {
      this.pageNum = 1;
      this.total = 0;
      this.deviceList = [];
      this.getSchoolBindDevice();
      this.selectnobinddevice();
    },
    // 点击修改按钮显示弹出框
    create(e) {
      // console.log("当前点击修改的信息==>", e.studentId);
      if (e) {
        this.editStudentInfo = e;
      }
      this.isCreateEditShow = true;
    },
    // 获取学校所有设备绑定学生信息
    getSchoolBindDevice() {
      // this.getListResult = "loading";
      let { deviceId, status, lossStatus, gradeId, classId, studentName } =
        this.searchInfo;
      let info = {
        schoolId: this.school.id,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceId,
        status,
        lossStatus,
        gradeId,
        classId,
        studentName,
      };
      this.post(this.$url.selectschoolbinddevice, info)
        .then((res) => {
          // console.log("当前学校所有设备绑定学生信息==>", res);
          if (res.code != 200) {
            this.getListResult = "error";
            // this.$message.error("获取列表失败！");
            return;
          }
          let data = res;
          this.total = data.total;
          this.total > 0
            ? (this.getListResult = "success")
            : (this.getListResult = "nullData");
          this.deviceList = data.rows;
        })
        .catch((err) => {
          console.log("获取所有设备绑定学校信息报错==>", err);
          this.getListResult = "error";
          this.$message.error("获取列表失败，请稍后再试");
        });
    },
    // 查询学校所有未绑定设备号
    selectnobinddevice() {
      this.post(this.$url.selectnobinddevice, {
        schoolId: this.school.id,
      })
        .then((res) => {
          // console.log("学校所有未绑定设备号==>", res);
          this.unboundList = res.data;
        })
        .catch((err) => {
          console.log("学校所有未绑定设备号获取失败==>", err);
        });
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getSchoolBindDevice();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getSchoolBindDevice();
    },
  },
};
</script>

<style scoped lang="deviceManage.scss">
@import "./deviceManage.scss";
</style>